import _ from 'lodash'
import { parseStringDateToISOString } from '../../utils/helpers/date'

const encode = encodeURIComponent

export const haveFilterQuery = (filter) => {
  const hasValueFilter = filter && !_.values(filter).some((x) => x === '')
  return hasValueFilter ? `?filter=${encode(filter)}` : `?`
}

export const haveSort = (sort) => {
  return sort ? `&sort=${sort}` : ''
}

export const paginator = (limit, skip) => {
  let result = ''
  if (limit) result = `&limit=${limit}`
  if (skip !== undefined) result = `${result}&skip=${skip * limit}`
  return result
}

export const dateRange = (initDate, finishDate) => {
  const iDate = parseStringDateToISOString(initDate)
  const fDate = parseStringDateToISOString(finishDate)
  return `initDate=${iDate}&finishDate=${fDate}`
}

export const buildQueryParams = (options) => {
  let queryParams = ''

  // Filtrar
  if (options?.filter) {
    const hasValueFilter =
      !_.isEmpty(options?.filter) &&
      !_.values(options?.filter).some((x) => x === '')
    if (hasValueFilter) {
      // ERROR: Este encoding NO debe hacerse. Corregido.
      // const filterString = encode(JSON.stringify(options?.filter))
      const filterString = options?.filter
      queryParams += `?filter=${filterString}`
    }
  }

  // Ordenar
  if (options?.sort) {
    queryParams += queryParams ? '&' : '?'
    queryParams += `sort=${options?.sort}`
  }

  // Paginación
  if (options?.limit || options?.limit === 0) {
    queryParams += queryParams ? '&' : '?'
    queryParams += `limit=${options?.limit}`
  }
  if (options?.skip !== undefined && options?.limit !== undefined) {
    queryParams += queryParams ? '&' : '?'
    queryParams += `skip=${options.skip * options.limit}`
  }

  if (options.initDate && options.finishDate) {
    const iDate = parseStringDateToISOString(options.initDate)
    const fDate = parseStringDateToISOString(options.finishDate)
    queryParams += queryParams ? '&' : '?'
    queryParams += `initDate=${iDate}&finishDate=${fDate}`
  }

  if (options.customParams !== undefined) {
    options.customParams.forEach((customParam) => {
      if (customParam.value !== null && customParam.value !== undefined) {
        queryParams += queryParams ? '&' : '?'
        queryParams += `${customParam.id}=${customParam.value}`
      }
    })
  }

  return queryParams
}
